import { applicationUrls, buildEnvironment } from './environment.shared';

export { applicationUrls };

export const environment = buildEnvironment(false);